import React, { Component } from 'react';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import { storageAvailable } from '../../common/storageAvailable';
import { clearLocalStorage, clearCookie } from '../../../utils/clearStorage';
import { generateEvent } from '../../../utils/dataGrinch';
import properties from '../../../modules/ajio-util/properties';
import SeoDropdown from '../../common/SeoDropdown';
import StickyFooter from '../pwa/StickyFooter';
import { getLuxeFlags } from '../../../Flags/selectors';
import { getCurrentStore } from '../../../refresh/selectors/metaData';

class Footer extends Component {
  getEventType(link) {
    if (link.includes('/shop/') || link.includes('/s/') || link.includes('/capsule/')) {
      return 'BottomNavClick';
    }
    return 'FooterClick';
  }

  linkClick = (link, name) => {
    generateEvent({
      Event: this.getEventType(link),
      value: {
        LinkName: name,
        LinkUrl: link,
        Screen: 'Mobile'
      }
    });
  };

  handleUrlClick(link) {
    return () => {
      if (link.url === '/home' || link.url === '/') {
        if (storageAvailable('localStorage')) {
          clearLocalStorage(['categoryClicked', 'categoryType', 'categoryPath', 'coreSelectedOn']);
        }
        clearCookie(['categoryClicked', 'categoryType', 'categoryPath', 'coreSelectedOn']);
        this.linkClick(`${properties.getProperty('parentUrl')}`, link.linkName);
      } else {
        const url = _get(link, 'fullUrl', 'url');
        localStorage.setItem('title', link.linkName);
        this.linkClick(url, link.linkName);
      }
      return true;
    };
  }

  render() {
    const {
      footer: footerdata = {},
      showStickyFooter = false,
      overrideFooterSeoContent = '',
      reqObjectForStickyFooter = null,
      stickyFooterFallbackStatus = false,
      bottomNavList = [],
      requestedUrl = '',
      newDesignLuxe
    } = this.props;
    if (Object.keys(footerdata).length === 0) {
      return showStickyFooter ? (
        <StickyFooter
          stickyFooterFallbackStatus={stickyFooterFallbackStatus}
          bottomNavList={bottomNavList}
          requestedUrl={requestedUrl}
          reqObjectForStickyFooter={reqObjectForStickyFooter}
        />
      ) : null;
    }
    const footerHeadlineDetail = (footerdata || []).childDetails?.map((item, i) => {
      return (
        <Tab eventKey={i} title={item.name} key={i}>
          <ul>
            {item.linkDetails?.map((link, j) => {
              if (link.isVisible != false) {
                let url = _get(link, 'fullUrl', 'url');
                if (url === '/home' || url === '/') {
                  url = `${properties.getProperty('parentUrl')}/home`;
                }
                return (
                  <li key={j}>
                    <a key={j} href={url} onClick={this.handleUrlClick(link)} title={link.linkName}>
                      {link.linkName}
                    </a>
                  </li>
                );
              }
            })}
          </ul>
        </Tab>
      );
    });

    return (
      <div className="main-footer" role="presentation">
        <div className="ftr-top" role="presentation">
          {!newDesignLuxe ? (
            <ul style={{ listStyle: 'none' }}>
              <li>
                <span role="presentation" className="ic-update" aria-hidden="true" />
                <span>
                  <strong>
                    EASY<br />
                    EXCHANGE
                  </strong>
                </span>
              </li>
              <li>
                <span role="presentation" className="ic-pikup" aria-hidden="true" />
                <span>
                  <strong>
                    100%<br />
                    HANDPICKED
                  </strong>
                </span>
              </li>
              <li>
                <span role="presentation" className="ic-qlty" aria-hidden="true" />
                <span>
                  <strong>
                    ASSURED<br />
                    QUALITY
                  </strong>
                </span>
              </li>
            </ul>
          ) : (
            <div className="luxe-exchange-mobile-img">
              <img
                alt='Trustmarker banner'
                src={`${properties.getProperty(
                  'imageBaseUrl'
                )}/static/img/luxe-easy-exchange-mobile.jpg`}
              />
            </div>
          )}
        </div>
        <div className="ftr-cont">
          <SeoDropdown overrideFooterSeoContent={overrideFooterSeoContent} isMsite />
          {showStickyFooter && (
            <StickyFooter
              stickyFooterFallbackStatus={stickyFooterFallbackStatus}
              bottomNavList={bottomNavList}
              requestedUrl={requestedUrl}
              reqObjectForStickyFooter={reqObjectForStickyFooter}
            />
          )}
          <div id="footer-tab">
            <Tabs defaultActiveKey={1}>{footerHeadlineDetail}</Tabs>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    bottomNavList: { fallback: stickyFooterFallbackStatus = false, list = [] } = {},
    location: { path: requestedUrl = '' } = {},
    flags
  } = state;

  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';

  return {
    newDesignLuxe,
    footer: state.footer,
    stickyFooterFallbackStatus,
    bottomNavList: list,
    requestedUrl
  };
}

export default connect(mapStateToProps, null)(Footer);
